import * as React from 'react';
import Box from '@mui/material/Box';

export default function Boxspacer() {
  return (
    <Box
      sx={{
        width: 20,
        height: 20,
        backgroundColor: '#66000000',
      }}
    />
  );
}
